import { TIER_COLOR } from '@/types/profiler';
import type { RiskTier } from '@/types/profiler';

interface Props {
  score: number;       // 0–100
  tier: RiskTier;
  size?: number;
  label?: string;
  showScore?: boolean;
}

export function RiskScoreRing({ score, tier, size = 80, label, showScore = true }: Props) {
  const color = TIER_COLOR[tier];
  const r = (size - 8) / 2;
  const circ = 2 * Math.PI * r;
  const pct = Math.min(100, Math.max(0, score)) / 100;
  const dashOn = +(pct * circ).toFixed(2);
  const dashOff = +(circ - dashOn).toFixed(2);
  const cx = size / 2;
  const cy = size / 2;
  const fontSize = Math.max(9, Math.round(size * 0.22));

  return (
    <svg
      width={size}
      height={size + (label ? 14 : 0)}
      viewBox={`0 0 ${size} ${size + (label ? 14 : 0)}`}
      aria-label={`Risk score: ${score}`}
    >
      {/* Track */}
      <circle
        cx={cx} cy={cy} r={r}
        fill="none"
        stroke={`${color}22`}
        strokeWidth={4.5}
      />
      {/* Progress */}
      <circle
        cx={cx} cy={cy} r={r}
        fill="none"
        stroke={color}
        strokeWidth={4.5}
        strokeDasharray={`${dashOn} ${dashOff}`}
        strokeLinecap="round"
        transform={`rotate(-90 ${cx} ${cy})`}
      />
      {showScore && (
        <text
          x={cx} y={cy}
          textAnchor="middle"
          dominantBaseline="central"
          fill={color}
          fontSize={fontSize}
          fontWeight={800}
          fontFamily="'JetBrains Mono', 'Courier New', monospace"
        >
          {Math.round(score)}
        </text>
      )}
      {label && (
        <text
          x={cx} y={size + 10}
          textAnchor="middle"
          fill="#5A7A9A"
          fontSize={7}
          fontFamily="monospace"
        >
          {label}
        </text>
      )}
    </svg>
  );
}
